// import React, { useState, useEffect } from 'react';
// import { getData } from '../global/Globalapi';
// import { IoMdArrowDropleftCircle, IoMdArrowDroprightCircle } from "react-icons/io";
// import { useNavigate } from "react-router-dom";
// import { encodeId } from "../global/Globalfunction";


// const ImageCarousel = ({ autoPlay = true, interval = 3000 }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [carouselImages, setCarouselImages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchImagesFromPrev = async () => {
//       setCarouselImages([]);
//       try {
//         setLoading(true);
//         const raw = localStorage.getItem('prev');
//         let prevProductIds = [];

//         try {
//           prevProductIds = JSON.parse(raw);
//           if (!Array.isArray(prevProductIds)) throw new Error();
//         } catch {
//           prevProductIds = raw ? raw.split(',') : [];
//         }

//         if (prevProductIds.length === 0) {
//           setCarouselImages([]);
//           setLoading(false);
//           return;
//         }

//         const allImages = [];
//         for (const productId of prevProductIds) {
//           try {
//             const response = await getData(`/product_images/${productId}`);
//             if (response.data && response.data.length > 0) {
//               const firstImage = response.data.find(img => img.display_order === 1) || response.data[0];
//               const imagePath = `http://localhost:5000/uploads/${firstImage.file_name}`;
//               allImages.push({ imagePath, productId });
//             }
//           } catch (error) {}
//         }

//         setCarouselImages(allImages);
//       } catch (error) {
//         setCarouselImages([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchImagesFromPrev();
//   }, []);

//   useEffect(() => {
//     if (!autoPlay || carouselImages.length <= 1) return;

//     const timer = setInterval(() => {
//       setCurrentIndex((prevIndex) =>
//         prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
//       );
//     }, interval);

//     return () => clearInterval(timer);
//   }, [autoPlay, interval, carouselImages.length]);

//   const goToSlide = (index) => setCurrentIndex(index);

//   if (loading) {
//     return (
//       <div className="relative w-full h-64 md:h-80 lg:h-[500px] xl:h-[600px] overflow-hidden group flex items-center justify-center bg-gray-200">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
//           <p className="text-gray-600">Loading carousel images...</p>
//         </div>
//       </div>
//     );
//   }

//   if (carouselImages.length === 0) {
//     return (
//       <div className="relative w-full h-64 md:h-80 lg:h-[500px] xl:h-[600px] overflow-hidden group flex items-center justify-center men-section-bg">
//         <div className="text-center text-gray-800">
//           <h2 className="text-2xl sm:text-4xl md:text-6xl font-bold mb-4">
//             Welcome to Bolt & Brook
//           </h2>
//           <p className="text-sm sm:text-lg md:text-xl" style={{ color: 'white' }}>
//             Discover amazing products and deals
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     // <div
//     //   key={carouselImages.length}
//     //   className="
//     //     mx-4 mb-4 sm:mx-0 xl:mx-auto
//     //     w-auto max-w-7xl
//     //     h-64 md:h-80 lg:h-[500px] xl:h-[600px] overflow-hidden group
//     //     rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300
//     //     bg-neutral-900
//     //   "
//     // >
//     <div
//   key={carouselImages.length}
//   className="
//     mx-4 mb-6 sm:mx-0 xl:mx-auto
//     w-full max-w-4xl
//     h-[220px] sm:h-[260px] md:h-[300px]
//     overflow-hidden group
//     rounded-xl shadow-md
//     bg-neutral-900
//   "
// >

//       <div className="relative w-full h-full flex flex-col md:flex-row ">
//         {carouselImages.map((imgObj, index) => (
//           <div
//             key={index}
//             className={`
//               absolute inset-0 transition-opacity duration-700 ease-in-out flex
//               flex-col md:flex-row
//               ${index === currentIndex ? 'opacity-100 scale-100 z-10' : 'opacity-0 scale-95 z-0'}
//             `}
//           >
//             {/* Left arrow button */}
//             <button
//               onClick={() => setCurrentIndex((prev) => (prev === 0 ? carouselImages.length - 1 : prev - 1))}
//               className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-transparent text-[#b37400] text-3xl sm:text-4xl md:text-5xl z-20 hover:-translate-x-1"
//               aria-label="Previous Slide"
//             >
//               <IoMdArrowDropleftCircle />
//             </button>

//             <img
//               src={imgObj.imagePath}
//               alt={`Carousel slide ${index + 1}`}
//               className="w-full h-full object-cover cursor-pointer"
//               onError={(e) => {
//                 e.target.style.display = 'none';
//               }}
//               //onClick={() => navigate(`/product/${imgObj.productId}`)}
//               onClick={() => navigate(`/product/${encodeId(imgObj.productId)}`)}

//             />

//             {/* Right arrow button */}
//             <button
//               onClick={() => setCurrentIndex((prev) => (prev === carouselImages.length - 1 ? 0 : prev + 1))}
//               className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-transparent text-[#b37400] text-3xl sm:text-4xl md:text-5xl z-20 hover:translate-x-1"
//               aria-label="Next Slide"
//             >
//               <IoMdArrowDroprightCircle />
//             </button>
//             <div onClick={() => navigate(`/product/${encodeId(imgObj.productId)}`)} className="absolute inset-0 bg-black opacity-0 hover:opacity-10 transition-all duration-600">
//               <p className="flex justify-center items-center h-full text-2xl sm:text-4xl md:text-6xl text-white text-center">T-Shirt</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* {carouselImages.length > 1 && (
//         <div className="absolute bottom-7 left-1/2 -translate-x-1/2 flex space-x-3">
//           {carouselImages.map((_, index) => (
//             <button
//               key={index}
//               onClick={() => goToSlide(index)}
//               className={`
//                 w-4 h-4 rounded-full border-2 border-white transition-all duration-300
//                 ${index === currentIndex
//                   ? 'bg-white shadow-lg'
//                   : 'bg-white bg-opacity-50 hover:bg-opacity-90'}
//               `}
//               aria-label={`Go to slide ${index + 1}`}
//               style={{ outline: 'none' }}
//             />
//           ))}
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default ImageCarousel;
// import React, { useEffect, useState } from "react";
// import { getData } from "../global/Globalapi";
// import { useNavigate } from "react-router-dom";
// import { encodeId } from "../global/Globalfunction";

// const ImageCarousel = () => {
//   const [products, setProducts] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchRecentProducts = async () => {
//       const raw = localStorage.getItem("prev");
//       if (!raw) return;

//       let productIds = [];
//       try {
//         productIds = JSON.parse(raw);
//       } catch {
//         productIds = raw.split(",");
//       }

//       if (!Array.isArray(productIds) || productIds.length === 0) return;

//       const result = [];

//       for (const productId of productIds) {
//         try {
//           const res = await getData(`/product_images/${productId}`);
//           if (res.data?.length) {
//             const img =
//               res.data.find(i => i.display_order === 1) || res.data[0];

//             result.push({
//               productId,
//               image: `http://localhost:5000/uploads/${img.file_name}`,
//             });
//           }
//         } catch (err) {
//           console.error("Image fetch failed", err);
//         }
//       }

//       setProducts(result);
//     };

//     fetchRecentProducts();
//   }, []);

//   if (products.length === 0) return null;

//   return (
//     <div className="py-6 px-6 md:px-16">
//       <h2 className="text-2xl font-bold mb-6 text-center">
//         Recently Viewed
//       </h2>

//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
//         {products.map((item, index) => (
//           <div
//             key={index}
//             onClick={() =>
//               navigate(`/product/${encodeId(item.productId)}`)
//             }
//             className="cursor-pointer bg-white rounded-lg shadow hover:shadow-xl transition"
//           >
//             <img
//               src={item.image}
//               alt="Recent product"
//               className="w-full h-48 object-cover rounded-t-lg"
//             />

//             <div className="p-3 text-center">
//               <p className="text-sm font-semibold text-gray-700">
//                 View Product
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ImageCarousel;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient, { getData, postData } from "../global/Globalapi";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import { toast } from "react-toastify";

const ImageCarousel = () => {
  const [products, setProducts] = useState([]);
  const [likedProducts, setLikedProducts] = useState({});
  const navigate = useNavigate();
  const baseURL = axiosClient.defaults.baseURL;
const getDisplayPrice = (product) => {
  // If product has variant/batch
  if (product.has_variant === 1) {
    return product.net_price_rtl;
  }

  // If no variant/batch
  return product.mrp_price;
};
  /* ---------------- FETCH RECENT PRODUCTS ---------------- */
  useEffect(() => {
    const fetchRecentProducts = async () => {
      const raw = localStorage.getItem("prev");
      if (!raw) return;

      let ids = [];
      try {
        ids = JSON.parse(raw);
      } catch {
        ids = raw.split(",");
      }

      if (!Array.isArray(ids) || ids.length === 0) return;

      const result = [];

      for (const rawId of ids.reverse()) {
        const productId = Number(rawId);
        if (!productId) continue;

        try {
          // 1️⃣ fetch product details
          const productRes = await getData(`/product/${productId}`);

          // 2️⃣ fetch product images
          const imageRes = await getData(`/product_images/${productId}`);

          let imageFile = null;
          if (imageRes.data?.length) {
            const img =
              imageRes.data.find(i => i.display_order === 1) ||
              imageRes.data[0];
            imageFile = img.file_name;
          }

          result.push({
            ...productRes.data,
            image_file: imageFile,
          });
        } catch (err) {
          console.error("Failed to fetch product:", productId);
        }
      }

      setProducts(result);
    };

    fetchRecentProducts();
  }, []);

  /* ---------------- CHECK WISHLIST ---------------- */
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || products.length === 0) return;

    const checkWishlist = async () => {
      const status = {};
      for (const p of products) {
        try {
          const res = await postData("/check", {
            product_id: p.product_id,
            user_id: user.id,
          });
          status[p.product_id] = res.status === 200;
        } catch {
          status[p.product_id] = false;
        }
      }
      setLikedProducts(status);
    };

    checkWishlist();
  }, [products]);

  /* ---------------- ADD TO CART ---------------- */
  const handleAddToCart = (productId) => {
    const encodedId = btoa(productId.toString());
    navigate(`/product/${encodedId}`);
  };

  /* ---------------- WISHLIST ---------------- */
  const handleWishlist = async (productId) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      toast.error("Please login to add wishlist");
      return;
    }

    try {
      await postData("/update-wish", {
        user_id: user.user_id,
        product_id: productId,
      });

      setLikedProducts(prev => ({
        ...prev,
        [productId]: !prev[productId],
      }));

      toast.success(
        likedProducts[productId]
          ? "Removed from wishlist"
          : "Added to wishlist"
      );
    } catch {
      toast.error("Wishlist update failed");
    }
  };

  if (products.length === 0) return null;

  return (
    <div className="py-6 px-6 md:px-16">
      <h2 className="text-3xl font-bold mb-8 text-center">
        Recently Viewed Products
      </h2>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {products.map(product => (
          <div
            key={product.product_id}
            className="bg-white rounded-lg shadow hover:shadow-xl transition relative"
          >
            <img
              src={
                product.image_file
                  ? `${baseURL}/uploads/${product.image_file}`
                  : "https://via.placeholder.com/300x200?text=No+Image"
              }
              alt={product.product_name}
              className="w-full h-48 object-cover rounded-t-lg"
            />

            {/* Wishlist */}
            <div
              className="absolute top-2 right-2 cursor-pointer z-10"
              onClick={() => handleWishlist(product.product_id)}
            >
              {likedProducts[product.product_id] ? (
                <FaHeart size={24} className="text-red-500" />
              ) : (
                <CiHeart size={24} className="text-gray-500" />
              )}
            </div>

            <div className="p-4 text-center">
              <h3 className="font-semibold mb-2">
                {product.product_name}
              </h3>
              <p className="text-blue-600 font-bold mb-2">
                {/* ₹{product.price} */}
                  {/* ₹ {getDisplayPrice(product)} */}
                     ₹{Number(getDisplayPrice(product)).toFixed(2)}
              </p>
              <button
                className="text-white px-4 py-2 bg-[#c97c5d] rounded hover:bg-orange-300 "
                onClick={() => handleAddToCart(product.product_id)}
              >
                {/* Add to Cart */}
                View
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
